import * as React from "react";
import { useState, useEffect } from "react";
import { Button, KIND } from "baseui/button";
import { Input } from "baseui/input";
import { useStyletron, styled } from "baseui";
import { MainContainer, InputContainer } from "./LoginStyles";
import { AuthForm, StyledLink } from './AuthForm'; // Import AuthForm

function LoginView(props) {
  const [css, theme] = useStyletron();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const validateUsername = (username) => {
    const regex = /^[A-Za-z0-9_]+$/; // regex for no spaces and no special characters
    return regex.test(username);
  };

  const validatePassword = (password) => {
    return password.length > 0; // simple check for non-empty password
  };

  const handleSignIn = () => {
    if (!validateUsername(username)) {
      setError("Username should not contain spaces or special characters.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password should not be empty.");
      return;
    }
    props.onSignIn(username, password);
    setUsername("");
    setError(""); // clear previous errors
    setPassword("");
  };

  useEffect(() => {
    setError(props.error);
  }, [props.error, props.isLoading]);

  return (
    <AuthForm error={error} isLoading={props.isLoading}>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              type="password"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <StyledLink onClick={props.onNavigate}>Forgot Password?</StyledLink>
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Button
              kind={KIND.primary}
              onClick={handleSignIn}
              isLoading={props.isLoading}
              overrides={{
                BaseButton: { style: { width: "100%" } },
              }}
            >
              {props.isLoading ? "Signing In..." : "Sign In"}
            </Button>
          </div>
          <div
            className={css({
              display: "flex", // Use flexbox
              flexDirection: "column", // Stack items vertically
              alignItems: "center", // Center horizontally
              marginBottom: theme.sizing.scale600,
            })}
          >
            <div>
              <span> New to Templize? </span>
              <StyledLink onClick={props.onNavigateToSignup}>
                Join Now
              </StyledLink>
            </div>
          </div>
        </AuthForm>

  );
}
export default LoginView;
